<script>
import Customers from "@/services/Customers";
import modalViewEmailAllEvents from "@/components/modals/customers/modalViewEmailAllEvents";

export default {
  name: "TabCustomerEmails",
  props: {
    recipient: {
      type: String,
      default: ""
    },
  },
  components: {modalViewEmailAllEvents},
  data() {
    return {
      isBusy: false,
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "event_datetime",
      sortDesc: true,
      messageId: '',
      messageData: [],
      tableFields: [
        {
            key: "from",
            label: "From",
            sortable: true,
        },
        {
            key: "subject",
            label: "Subject",
            sortable: false,
        },
        {
            key: "email_type",
            label: "Email Type",
            sortable: false,
        },
        {
            key: "eventType",
            label: "Event Type",
            sortable: true,
        },
        {
            key: "eventTypeDetail",
            label: "Event Type Detail",
            sortable: true,
        },
        {
          key: "event_datetime",
          label: "Event Datetime",
          sortable: true,
        },
        "Action"
      ]
    };
  },
  watch: {
    recipient: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal !== '') {
          this.getEmailsStats({ recipient: newVal });
        }
      }
    }
  },
  methods: {

    async getEmailsStats(filters = {}) {
      try {
        this.toggleBusy();
        this.loaderCountEmails = true;

        // Build query params
        const params = new URLSearchParams(filters).toString();
        const response = await Customers.getEmailsStats(params);
        const emails = response.data.data.emails || [];

        // Table data
        this.tableData = Object.values(
            emails.reduce((acc, item) => {
              const key = item.messageId;

              if (!acc[key]) {
                acc[key] = {...item};
              } else {
                const existingDate = new Date(acc[key].event_datetime);
                const currentDate = new Date(item.event_datetime);

                if (currentDate > existingDate) {
                  acc[key] = {...item}; // keep real latest event
                }
              }

              return acc;
            }, {})
        );
        this.totalRows = emails.length;

      } catch (error) {
        this.error = error.response?.data?.error || "";
        this.tableData = [];
        this.totalRows = 0;

      } finally {
        this.toggleBusy();
      }
    },

    viewMessageDetails(messageId, messageData){
      this.messageId = messageId;
      this.messageData = messageData;
      this.$bvModal.show("view_message_events");
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

  }
}
</script>

<template>
  <div class="col-12">

    <!-- Table -->
    <b-table
        :busy="isBusy"
        :items="tableData"
        :fields="tableFields"
        responsive
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        show-empty
        empty-text="No Data Found"
        @filtered="onFiltered"
    >

      <template v-slot:cell(action)="data">
        <ul class="list-inline mb-0">
          <li class="list-inline-item">
            <a href="javascript:void(0);" class="px-2 text-primary"
               title="View Message Details" @click="viewMessageDetails(data.item.messageId, data.item)">
              <i class="uil uil-eye font-size-18"></i>
            </a>
          </li>
        </ul>
      </template>

      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

    </b-table>

    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>

    <modalViewEmailAllEvents :messageData="messageData" :messageId="messageId"></modalViewEmailAllEvents>
  </div>

</template>